<div [class.error]="error">
  <a class="product-image" [routerLink]="createProductUrl(product)" tabindex="-1" aria-hidden="true">
    <img [src]="product | primary" [alt]="product.productDisplayName" (load)="cdr.detectChanges()" />
  </a>
  <a class="product-info" [routerLink]="createProductUrl(product)">
    <div class="basket-product-description">
      <b>{{ product.productDisplayName }}</b>
      @let moduleChoices = product | modules;
      @for (module of moduleChoices; track module.id) {
        <div class="modules">
          <span>{{ module.quantity }} X {{ module.productDisplayName }}</span>
        </div>
      }
    </div>
  </a>
  <span class="basket-price">{{ calculatePrice() | number: '.2-2' : locale }} {{ currency | displayCurrency }}</span>
  <div class="basket-quantity">
    <app-counter
      [minCount]="product.minCount"
      [count]="quantity"
      [packageOptions]="product.packageOptions"
      (add)="addProduct(product, $event.quantity, $event.packageOptions)"
      (remove)="removeProduct(product, quantity, $event.quantity, $event.packageOptions)"
    ></app-counter>
    <app-icon-button icon="trash" [border]="false" (click)="deleteProduct(product)"></app-icon-button>
  </div>
</div>
